import React from 'react';
import { ReactComponent as ChatIcon } from 'assets/images/icons/chat.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/icons/delete_24px.svg';
import { InputComponent } from 'component/Input';
import { toast } from 'react-toastify';
import axios from 'axios';

export const CommentBlock = ({
  comments,
  savedComment,
  commentForm,
  commentEntered,
  block,
  onDeleteComment,
  handleComments,
  onSaveComment,
}) => (
  <>
    <CommentDisplay comments={comments} block={block} />
    <div className="comment-view-block">
      {savedComment?.[block] && (
        <div className="block-with-comment">
          <div className="icon-with-comment">
            <ChatIcon style={{ width: '20px' }} />
            <div className="comment">{savedComment[block]}</div>
          </div>
          <div className="comment-buttons">
            <DeleteIcon
              className="delete-comment-button"
              style={{ cursor: 'pointer' }}
              onClick={(e) => onDeleteComment(e, block)}
            />
          </div>
        </div>
      )}

      {!commentEntered[block] && (
        <div className="input-with-button">
          <InputComponent
            classNameWrapper="w-100"
            style={{ width: '-webkit-fill-available' }}
            className="input-view"
            handleInput={(value) => handleComments(block, value)}
            onBlur={(e) => onSaveComment(e, block)}
            value={commentForm?.[block]}
            placeholder="Add comment"
          />
        </div>
      )}
    </div>
  </>
);

export const CommentDisplay = ({ comments, block }) => {
  const rejectedComments = [];

  if (comments && Array.isArray(comments)) {
    comments.forEach((commentItem) => {
      const commentText = commentItem?.comments?.[block];

      if (commentText && commentText?.trim() !== '' && commentItem?.steps && Array.isArray(commentItem?.steps)) {
        commentItem?.steps?.forEach((step) => {
          if (step?.status === 'rejected' && step?.user) {
            rejectedComments.push({
              ...step,
              commentText: commentText
            });
          }
        });
      }
    });
  }

  const filteredComments = rejectedComments.reverse();

  return (
    <>
      {filteredComments?.map((item, index) => (
        <div
          key={index}
          className="comment-block-item"
          style={{
            alignItems: 'center',
            backgroundColor: index === 0 ? '#00bc134d' : '#f5f5f5',
            borderRadius: '20px',
            color: '#878787',
            display: 'flex',
            fontSize: '14px',
            gap: '10px',
            marginBottom: '20px',
            padding: '16px',
            width: '95%'
          }}
          >
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <span style={{ fontWeight: '500', color: '#878787' }}>
                {item?.user?.name} {item?.user?.surname}
              </span>
              <span style={{ color: '#878787', fontSize: '12px', marginLeft: '4px' }}>
                ({item?.user?.role?.short_name})
              </span>
              <ChatIcon
                style={{
                  width: '16px',
                  height: '16px',
                  color: '#838d83',
                  flexShrink: 0,
                  marginLeft: '8px'
                }}
              />
              <span style={{ color: '#878787', lineHeight: '1.4', fontSize: '14px', marginLeft: '20px' }}>
                {item?.commentText}
              </span>
            </div>
        </div>
      ))}
    </>
  );
};

export const handleReportValidation = async (
  status,
  event,
  url,
  redirectPath,
  setLoader,
  savedComment,
  resetCommentForm,
  navigate,
  dispatch,
) => {
  event.preventDefault();

  if (dispatch) {
    dispatch({ type: 'SET_LOADER', payload: true });
  } else if (setLoader) {
    setLoader(true);
  }

  if (status === 'accepted') {
    resetCommentForm();
  }

  try {
    await axios.put(url, {
      status,
      comments: savedComment,
    });

    toast.success(status === 'accepted' ? 'Accepted' : 'Rejected');
    setTimeout(() => navigate(redirectPath), 1000);
  } catch (err) {
    if (err?.response?.status === 400) {
      toast.error(err?.response?.data.error);
    } else if (err?.response?.status === 500) {
      toast.error('Error');
      toast.success('Please try again');
    }
    toast.error(
      `Error ${status === 'accepted' ? 'accepting' : 'rejecting'
      } report. Please try again.`,
    );
  } finally {

    if (dispatch) {
      dispatch({ type: 'SET_LOADER', payload: false });
    } else if (setLoader) {
      setLoader(false);
    }
  };
};
